import { useState } from "react";

import iPlus from "../../assets/images/100-add-black.svg";
import iCalender from "../../assets/images/100-calender.svg";
import iChevronDown from "../../assets/images/100-chevron-down.svg";
import iClock from "../../assets/images/100-clock.svg";
import iClose from "../../assets/images/100-close-gray.svg";
import iEmail from "../../assets/images/100-email.svg";
import iUploadTick from "../../assets/images/100-tick-green.svg";
import iUploadImg from "../../assets/images/100-upload-img.svg";
import iUploadVideo from "../../assets/images/100-upload-video.svg";
import defaultImage from "../../assets/tutorial-items/i10.svg";
import ToggleButton from "../../components/ToggleButton";
import { useLiveWorkspaceCreationContext } from "../../contexts/LiveWorkspaceCreationContext";

const CreationSidebar = () => {
  const { selectedCourses, setSelectedCourses, workspaceTitle, setWorkspaceTitle, workspaceDesc, setWorkspaceDesc, creating } =
    useLiveWorkspaceCreationContext();

  const [dd1, setdd1] = useState("select...");
  const [dd1isOpen, setdd1isOpen] = useState(false);

  const [dd2, setdd2] = useState("select...");
  const [dd2isOpen, setdd2isOpen] = useState(false);

  const [dd3, setdd3] = useState(1);
  const [dd3isOpen] = useState(false);

  const deselectCourse = (course) => {
    setSelectedCourses((prev) => prev.filter((c) => c !== course));
  };

  return (
    <div className="create-meeting-sidebar">
      <div className="w-100p" style={{ position: "relative" }}>
        {/* Side Bar Form */}
        <div className="font-18">Choose Template</div>
        <div className="font-16 p-tb-24">First, let’s choose a template for your live workspace.</div>
        <div className="p-b-9">Your choices are:</div>

        {!selectedCourses.length && (
          <div className="box-uploader">
            <div className="empty-item">
              <img src={iPlus} width={18} height={18} alt="" />
            </div>
            <span className="m-l-16">Select from the left list.</span>
          </div>
        )}

        {selectedCourses.length > 0 && (
          <div className="box-uploader flex-col">
            {selectedCourses.map((course, i) => (
              <div key={i} className="create-meeting-thumbnail pointer">
                <div className="align-items-center">
                  <img src={course.imgPath || defaultImage} width={75} height={48} alt="" />
                  <span className="m-l-16"> {course.title || `Course ${course.cid}`} </span>
                </div>
                <img src={iClose} width={16} height={16} onClick={() => deselectCourse(course)} alt="" />
              </div>
            ))}
          </div>
        )}

        <div className="align-items-center m-tb-24">
          <ToggleButton /> <span className="m-l-16">Customize the template</span>
        </div>

        <div className="p-b-24">
          <div className="p-b-9">Upload custom cover</div>
          <div className="box-uploader">
            <div className="empty-item">
              <img src={iUploadImg} width={18} height={18} className="pointer" alt="" />
            </div>
            <div className="m-l-16 flex-col text-box">
              <span>
                Drag & drop your image here, or&nbsp;
                <span className="text-blue pointer">browse</span>
              </span>
              <span className="font-10 text-gray1">Support JPG, PNG, 10 MB max file size.</span>
            </div>
          </div>
        </div>

        <div className="p-b-24">
          <div className="p-b-9">
            Starting video <span className="dev-mode"> (hover, show uploading mode) </span>
          </div>
          <div className="box-uploader uploading">
            <div className="empty-item">
              <img src={iUploadVideo} width={18} height={18} className="pointer" alt="" />
            </div>
            <div className="m-l-16 flex-col text-box">
              <span>
                Drag & drop your image here, or&nbsp;
                <span className="text-blue pointer">browse</span>
              </span>
              <span className="font-10 text-gray1">Support JPG, PNG, 10 MB max file size.</span>
            </div>
            <div className="pointer hide" id="cancel">
              cancel
            </div>
          </div>
        </div>

        <div className="p-b-24">
          <div className="p-b-9">
            Starting video <span className="dev-mode"> (upload complete) </span>
          </div>
          <div className="box-uploader">
            <div className="empty-item">
              <img src={iUploadVideo} width={18} height={18} className="pointer" alt="" />
            </div>
            <div className="m-l-16 flex-col text-box">
              <span>demp.mp4</span>
              <span className="font-10 text-gray1">1.2 MB - Done</span>
            </div>
            <div className="m-l-28">
              <img src={iUploadTick} alt="" />
            </div>
          </div>
        </div>

        <div className="m-b-24">
          <div className="font-18"> Add Title & Description</div>
          <div className="flex-col m-t-24">
            <label htmlFor="meeting-title">Title</label>
            <input
              type="text"
              placeholder="title..."
              className={`fg ${!workspaceTitle && "error"}`}
              value={workspaceTitle}
              onChange={(e) => setWorkspaceTitle(e.target.value)}
            />
          </div>
          <span className={`input-error ${workspaceTitle && "visibility-hidden"}`}>Meeting Name is required</span>
        </div>

        <div className="flex-col">
          <label htmlFor="meeting-description">Description</label>
          <textarea name="description" rows="4" cols="50" className="fg" value={workspaceDesc} onChange={(e) => setWorkspaceDesc(e.target.value)} />
        </div>

        <div className="m-t-32 m-b-24">
          <div className="font-18"> Schedule</div>
        </div>

        <div className="space-between">
          <div className="list-dropdown">
            <div className="list-dropdown-label">Date</div>
            <div className={`w-150 list-dropdown-contaner ${dd1isOpen && "open-list-dropdown"}`} onClick={() => setdd1isOpen(!dd1isOpen)}>
              <div className="list-dropdown-title">
                <span>
                  <img src={iCalender} width={18} alt="" /> {dd1}
                </span>
                <span className="flex">
                  <img src={iChevronDown} className="chervon" alt="" />
                </span>
              </div>
              {dd1isOpen && (
                <div className="list-dropdown-items">
                  <ul onClick={(e) => setdd1(e.target.innerText)}>
                    <li>Nov 21</li>
                    <li>Nov 22</li>
                    <li>Nov 23</li>
                    <li>Nov 24</li>
                    <li>Nov 25</li>
                  </ul>
                </div>
              )}
            </div>
          </div>

          <div className="list-dropdown">
            <div className="list-dropdown-label">Time</div>
            <div className={`w-130 list-dropdown-contaner ${dd2isOpen && "open-list-dropdown"}`} onClick={() => setdd2isOpen(!dd2isOpen)}>
              <div className="list-dropdown-title">
                <span>
                  <img src={iClock} width={18} alt="" /> {dd2}
                </span>
                <span className="flex">
                  <img src={iChevronDown} className="chervon" alt="" />
                </span>
              </div>
              {dd2isOpen && (
                <div className="list-dropdown-items">
                  <ul onClick={(e) => setdd2(e.target.innerText)}>
                    <li>12:00</li>
                    <li>13:00</li>
                    <li>14:00</li>
                    <li>15:00</li>
                    <li>16:00</li>
                  </ul>
                </div>
              )}
            </div>
          </div>

          <div className="list-dropdown">
            <div className="list-dropdown-label">Duration</div>
            <div className={`w-120 list-dropdown-contaner ${dd3isOpen && "open-list-dropdown"}`}>
              <div className="list-dropdown-title">
                <span>
                  <span className="w-20">{dd3}</span>
                  <span className="text-gray1">hours</span>
                </span>
                <span className="flex-col h-44">
                  <span>
                    <img src={iChevronDown} width={11.25} height={5.63} className="rotate-180 m-b-8" onClick={() => setdd3(dd3 + 1)} alt="" />
                  </span>
                  <span>
                    <img src={iChevronDown} width={11.25} height={5.63} onClick={() => setdd3(dd3 - 1)} alt="" />
                  </span>
                </span>
              </div>
              {/* {dd3isOpen && (
                  <div className="list-dropdown-items">
                    <ul onClick={(e) => setdd3(e.target.innerText)}>
                      <li>1</li>
                      <li>2</li>
                      <li>3</li>
                      <li>4</li>
                      <li>5</li>
                    </ul>
                  </div>
                )} */}
            </div>
          </div>
        </div>

        <div className="m-t-32 m-b-24">
          <div className="font-18"> Add Participants</div>
          <div className="flex-col m-t-24">
            <div className="input-with-icon">
              <label htmlFor="meeting-email">Email address</label>
              <input type="email" placeholder="e.g. name@domain.com" className="fg" />
              <img src={iEmail} alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreationSidebar;
